import type { UnobtrusiveValidation } from "@Validation/UnobtrusiveValidation";
import Collapse from "bootstrap/js/dist/collapse";

export class Positions
{
	public EquipmentCollapse: Collapse | null = null;
	public Form: HTMLFormElement;
	public Validation: UnobtrusiveValidation;
	public WarehouseCollapse: Collapse | null = null;

	constructor(validation: UnobtrusiveValidation, form: HTMLFormElement)
	{
		this.Validation = validation;
		this.Form = form;
		this.ConfigureEquipmentPosition();
		this.ConfigureWarehousePosition();
		this.ConfigureCanPerformJob();
	}

	public ConfigureCanPerformJob = (): void =>
	{
		const canPerformJobYes = document.getElementById("CanPerformJobYes") as HTMLInputElement;

		document.querySelectorAll("input[name='CanPerformJob']")?.forEach(input =>
		{
			input.addEventListener("change", (e) =>
			{
				this.Validation.Service.isFieldValid(canPerformJobYes);
			});
		});
	}

	public ConfigureCollapseListener = (input: HTMLInputElement, collapse: Collapse): void =>
	{
		input.addEventListener("change", (e) =>
		{
			if (input.checked)
			{
				collapse.show();
			}
			else
			{
				collapse.hide();
			}
		});
	}

	public ConfigureEquipmentPosition = (): void =>
	{
		const applyingForEquipmentPosition = document.getElementById("ApplyingForEquipmentPosition") as HTMLInputElement;
		const equipmentCollapse = document.getElementById("equipmentCollapse") as HTMLElement;

		if (applyingForEquipmentPosition && equipmentCollapse)
		{
			this.EquipmentCollapse = new Collapse(equipmentCollapse, { toggle: false });

			this.ConfigureCollapseListener(applyingForEquipmentPosition, this.EquipmentCollapse);
		}
	}

	public ConfigureWarehousePosition = (): void =>
	{
		const applyingForWarehousePosition = document.getElementById("ApplyingForWarehousePosition") as HTMLInputElement;
		const warehouseCollapse = document.getElementById("warehouseCollapse") as HTMLElement;

		if (applyingForWarehousePosition && warehouseCollapse)
		{
			this.WarehouseCollapse = new Collapse(warehouseCollapse, { toggle: false });

			this.ConfigureCollapseListener(applyingForWarehousePosition, this.WarehouseCollapse);
		}
	}
}